import { IGuestDetails, IReservation, ReservationStatus } from '@localina/core';
import { useEffect } from 'react';

interface IPagedReservations {
    data?: { pages: { items: IReservation[] }[] };
    hasNextPage?: boolean;

    isFetching: boolean;
    fetchNextPage: () => void;
}

export interface IGuestStats {
    visits: number;

    averageParty?: number;

    noShows?: number;
}

export const useGuestStats = (
    details: IGuestDetails | undefined,
    reservations: IPagedReservations,
): IGuestStats | undefined => {
    const { hasNextPage, isFetching, fetchNextPage } = reservations;

    useEffect(() => {
        if (hasNextPage && !isFetching) {
            fetchNextPage();
        }
    }, [hasNextPage, isFetching, fetchNextPage]);

    if (!details) {
        return undefined;
    }

    const items = (reservations.data?.pages ?? []).flatMap((page) => page.items);
    const isComplete = items.length >= details.numReservations;

    if (!isComplete) {
        return { visits: details.numReservations };
    }

    const noShows = items.filter((item) => item.status === ReservationStatus.NO_SHOW).length;

    const participants = items.reduce((total, item) => total + item.participants, 0);

    return {
        visits: details.numReservations,
        averageParty: items.length > 0 ? participants / items.length : undefined,
        noShows,
    };
};
